import { splitABTestsAndFeatureFlags } from 'utils/splitABTestsAndFeatureFlags';

export default () => {
  return splitABTestsAndFeatureFlags(
    // eslint-disable-next-line camelcase
    window.manomano?.featureFlags_abTests,
  ).featureFlags;
};
